import { TIMEZONES } from '@src/constants';
import { createSchema, Yup } from '@src/corelib/validation';


/**
 * Business details form (T11). All nine fields are optional strings — the
 * original page never client-validated them, leaving enforcement to the server
 * (which still maps 400 field errors back onto the inputs via the Form's
 * `showServerErrors`). Timezone defaults to `UTC` and always offers the seller's
 * current zone even when it falls outside the bounded `TIMEZONES` list.
 */

const FIELD_KEYS = [
  'name',
  'contact_email',
  'contact_phone',
  'timezone',
  'address',
  'city',
  'region',
  'postal_code',
  'business_hours',
];


const businessSchema = createSchema(
  Object.fromEntries(FIELD_KEYS.map((key) => [key, Yup.string()])),
);


/** Map a seller record onto the form's string-valued shape (timezone → UTC). */
function businessDefaults(seller) {
  return Object.fromEntries(
    FIELD_KEYS.map((key) => [key, seller?.[key] || (key === 'timezone' ? 'UTC' : '')]),
  );
}


/** Timezone `<option>` list, with the seller's current zone prepended when it
 * is not already one of the bounded choices. */
function timezoneOptions(currentZone) {
  const zones = TIMEZONES.includes(currentZone) ? TIMEZONES : [currentZone, ...TIMEZONES];
  return zones.map((zone) => ({ value: zone, label: zone }));
}


export {
  businessDefaults,
  businessSchema,
  FIELD_KEYS,
  timezoneOptions,
};
